import { getDataTestId } from '../../shared/esm';
import { Caption } from './components/caption/Component.js';
import { Controls } from './components/controls/Component.js';
import { Graphic } from './components/graphic/Component.js';
import { Subtitle } from './components/subtitle/Component.js';
import { Title } from './components/title/Component.js';
import 'react';
import 'classnames';
import './Context.js';

function createCompound(functionComponent) {
    return Object.assign(functionComponent, {
        Graphic: Graphic,
        Title: Title,
        Subtitle: Subtitle,
        Caption: Caption,
        Controls: Controls,
    });
}
function getSystemMessageTestIds(dataTestId) {
    return {
        systemMessage: dataTestId,
        caption: getDataTestId(dataTestId, 'caption'),
        controls: getDataTestId(dataTestId, 'controls'),
        graphic: getDataTestId(dataTestId, 'graphic'),
        subtitle: getDataTestId(dataTestId, 'subtitle'),
        title: getDataTestId(dataTestId, 'title'),
    };
}

export { createCompound, getSystemMessageTestIds };
